/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { FractionDependencies } from './dependenciesFractionClass.generated';
import { complexDependencies } from './dependenciesComplex.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createSign } from '../../factoriesAny.js';
export var signDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  FractionDependencies: FractionDependencies,
  complexDependencies: complexDependencies,
  typedDependencies: typedDependencies,
  createSign: createSign
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSign.generated.js
// module id = 651
// module chunks = 0